import { useState } from "react";
import { Button, FormGroup, FormLabel } from "react-bootstrap";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { API } from "../../utils/AxiosInstance";
import { WebLayout } from "../components/web-layout";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addServerErrors } from "../../utils/react-hook-form-utils";
import { isValidationError } from "../../utils/axios-utils";
import { ServerError } from "../../types/server-error";
import { Spinner } from "../components/spinner";

async function fetchItem(token: string) {
    const { data } = await API.get(`/password_resets/${token}/edit`);
    return data;
}

const schema = yup.object().shape({
    password: yup
        .string()
        .min(8, "has to be equal or longer than 8 characters!")
        .required("is required"),
    confirm_password: yup
        .string()
        .test("match", "password do not match", function (confirm_password) {
            return confirm_password === this.parent.password;
        })
        .required("is required"),
});

interface State {
    password: string;
    confirm_password: string;
}

export function Register() {
    const { token } = useParams<{ token: string }>();
    const { isFetching, isError, isFetched } = useQuery(
        ["careplan-register", token],
        () => fetchItem(token!)
    );
    const [isSaving, setIsSaving] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm<State>({
        resolver: yupResolver(schema),
    });

    async function onSubmit(params: State) {
        try {
            setIsSaving(true);
            await API.put(`/password_resets/${token!}`, params);
            alert("Password successfuly updated.");
            window.location.href = "/";
        } catch (e) {
            if (isValidationError<ServerError>(e)) {
                addServerErrors<State>(e.data.errors, setError);
            }
            setIsSaving(false);
        }
    }

    return (
        <WebLayout>
            {isFetching && <Spinner />}
            {isError && <p>Token has been expired</p>}
            {isFetched && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup>
                        <FormLabel>Password</FormLabel>
                        <input
                            type="password"
                            className="form-control"
                            {...register("password")}
                        />
                        <i className="text-xs">
                            Must contain a letter, a number and a symbol. It
                            must be at least 8 characters long.
                        </i>
                        <br />
                        {errors.password && (
                            <small className="text-danger">
                                {errors.password.message}
                            </small>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <FormLabel>Confirm Password</FormLabel>
                        <input
                            type="password"
                            className="form-control"
                            {...register("confirm_password")}
                        />
                        {errors.confirm_password && (
                            <small className="text-danger">
                                {errors.confirm_password.message}
                            </small>
                        )}
                    </FormGroup>
                    <div className="text-right">
                        <Button type="submit" disabled={isSaving}>
                            Submit {isSaving && <Spinner size="sm" />}
                        </Button>
                    </div>
                </form>
            )}
        </WebLayout>
    );
}
